// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Phone_modalOverlay__B4vsO","modal":"Phone_modal__4GFaU","deleteImage":"Phone_deleteImage__M7i0t"};